export const UPDATE_GRADE_QUERIES = [
  'classAssignments',
  'classesAndStudents',
  'teacherClassTaskSummary',
  'assignmentSubmissions',
]
export const UPDATE_ASSIGNMENT_QUERIES = ['teacherClassTaskSummary']
